import { useState } from 'react';
import swal from 'sweetalert';
import Swal from 'sweetalert2';
import AddEditExcursionModal from './AddEditExcursionModal';
import ExcursionService from '../../repository/tourRepository/ExcursionRepository';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as EditPen } from '../../assets/icons/EditPen.svg';
import { ReactComponent as DeleteX } from '../../assets/icons/DeleteX.svg';
import { ReactComponent as Details } from '../../assets/icons/Details.svg';
import '../../App.css';
import { strings } from '../../localization/Localization';
import { useAuth } from '../Auth/AuthContext';

const ExcursionTerm = (props) => {

  const [selectedExcursionForEdit, setSelectedExcursionForEdit] = useState({});
  const [showEditModal, setShowEditModal] = useState(false);
  const { isAdmin } = useAuth();

  const navigate = useNavigate();

  const handleShowEditExcursionModal = () => {
    setShowEditModal(true);
  };

  const handleCloseEditExcursionModal = () => {
    setSelectedExcursionForEdit({});
    setShowEditModal(false);
  };

  const openExcursionDetailsPage = () => {
    navigate(`/excursion-details/${props.excursion.id}`, {
      state: {
        excursion: props.excursion,
        excursionName: props.excursion.name
      },
    });
  };

  const deletedSuccessfullyAlert = () => {
    Swal.fire({
      icon: 'success',
      title: strings.excursionDeletedSuccessfully,
    });
  };

  const errorAlert = () => {
    swal({
      title: strings.somethingWentWrong,
      icon: 'error',
      dangerMode: true
    }).then((willDelete) => {
      if (willDelete) {
      }
    });
  };

  const deleteExcursion = (id) => {
    ExcursionService.deleteExcursion(id)
      .then(() => {
        deletedSuccessfullyAlert();
        props.getExcursions();
        props.handleClose();
      }).catch(() => {
      errorAlert();
    });
  };

  const ConfirmationDelete = (id) => {
    Swal.fire({
      title: strings.confirmationDelete,
      icon: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      dangerMode: true,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteExcursion(id);
      }
    });
  };

  return (
    <>
      <AddEditExcursionModal showModal={showEditModal}
                             handleClose={handleCloseEditExcursionModal}
                             selectedExcursionForEdit={selectedExcursionForEdit}
                             getExcursions={props.getExcursions}
      />
      <tr key={props.excursion.id}>
        <td className={'cursor-pointer'}>{props.excursion.id}<Details width='30px' height='30px'
                                                                      onClick={openExcursionDetailsPage}/>
        </td>
        <td>{props.excursion.name}</td>
        <td>{props.excursion.placeTo}</td>
        <td>{props.excursion.dateFrom}</td>
        <td>{props.excursion.dateTo.split('T')[0]}</td>
        <td>{props.excursion.price}</td>
        <td>{props.excursion.discount}</td>
        <td>{props.excursion.totalSeats}</td>
        <td>{props.excursion.bookedSeats}</td>
        {isAdmin && (
          <td>
          <span className={'d-flex'}>
            <a className={'cursor-pointer'} onClick={() => {
              setSelectedExcursionForEdit(props.excursion);
              handleShowEditExcursionModal();
            }}>
              <EditPen width='30px' height='30px'/>
            </a>
            <a className={'cursor-pointer'} onClick={() => ConfirmationDelete(props.excursion.id)}>
              <DeleteX width='30px' height='30px'/></a>
          </span>
          </td>
        )}
      </tr>
    </>
  );

};
export default ExcursionTerm;